module.exports = __webpack_public_path__ + "static/media/sparda-bank-logo.63e3454e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparda-bank-logo.svg
// module id = 306
// module chunks = 1